module.exports = __webpack_public_path__ + "img/direct-install.01a4750a.png";